<template>
    <div id="ChangePwd">

        <div class="g-right-middle width800 g-ypxx">
        	<p>
        		<span class='ypxx-left'>密码</span>
        		<span class="ypxx-right">
					<input type="password"  v-model="password" placeholder="请输入您要修改的密码">
				</span>
				<div class="clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'>确认密码</span>
				<span class="ypxx-right">
					<input type="password"  v-model="password_confirm" placeholder="请再次输入您要修改的密码">
				</span>
				<div class="clearfix"></div>
			</p>
			<center><input @click="changepwd" type="button" class="g-btn" value="确认提交"></center>
		</div>
    </div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default{
		data(){
			return{
				password:'',
				password_confirm:''
			}
		},
		methods:{
			changepwd(){
				var api='https://api.yopoo.cn/api/centre/updatePassword'
				let updateinfo={
					password:this.password,
					password_confirm:this.password_confirm
				}
				Axios.post(api,updateinfo).then((res)=>{

					if(res.data.code=='200'){
						this.$message({
							message: res.data.msg,
							type: 'success',
							center:true

						});
							setTimeout(() => {
									this.$router.push('/group_admin/changemobile')
								}, 200);
					}else{
						this.$message({
							message: res.data.msg,
							type: 'error',
							center:true

						});
					}
				}).catch((res)=>{

				})
			}
		}
	}
</script>
<style>
	#ChangePwd input[type=password]{
		width: 350px;
border-radius: 5px;
border: 1px solid #d9d9d9;
padding-left: 5px;
height: 34px;
font-size: 14px;
color: #555;
background: #f4f4f4;
	}

</style>



// WEBPACK FOOTER //
// src/components/group_admin/change/G_ChangePwd.vue